import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {
    ApiCallOptions,
    LoginNewsResponseBody,
    LoginNotificationsResponseBody
} from './api.d';

export const getLoginNews = (locale: string, options: ApiCallOptions = {}) => createApiCall<LoginNewsResponseBody>(
    SERVICE_NAMES.RESOURCE,
    'GET',
    `${locale}/newsitems-loginpage`
)({...options});

export const getLoginNotifications = (locale: string, options: ApiCallOptions = {}) => createApiCall<LoginNotificationsResponseBody>(
    SERVICE_NAMES.RESOURCE,
    'GET',
    `${locale}/notifications-loginpage`
)({...options});

export const resourceApi = {
    getLoginNews,
    getLoginNotifications
};
